const ContinentPicker: React.FC<{
  continentLabel: string;
  continentImage: any;
  continentValue: string;
  continentIsActive?: boolean;
  continentChangeHandler: any;
}> = (props) => {
  const continentChangeHandler = () => {
    props.continentChangeHandler(props.continentValue, props.continentIsActive);
  };

  return (
    <div
      tabIndex={0}
      className={`continent ${
        props.continentIsActive ? "continent--active" : ""
      }`}
      onClick={continentChangeHandler}
    >
      <img
        src={props.continentImage}
        alt={props.continentLabel}
        className="continent__image"
      />
      <h4 className="continent__heading">{props.continentLabel}</h4>
    </div>
  );
};

export default ContinentPicker;
